/**
 * "Was ist neu": the family-facing release notes (apps/web/src/whats-new.md) as data. Pure so it
 * can be tested here – the web app has no unit test runner of its own.
 */
export interface Release {
  /** "1.2" */
  version: string;
  /** "1. Oktober 2026", if the heading names it */
  date?: string;
  intro: string[];
  items: string[];
}

/** "1.2.0" → "1.2" – the family sees major.minor, patches are invisible fixes. */
export const shortVersion = (v: string) => v.split('.').slice(0, 2).join('.');

/** `## Version 1.2 – 1. Oktober 2026`, an optional intro, then `- ` bullets. */
export function parseReleases(md: string): Release[] {
  return md
    .split(/^## /m)
    .slice(1)
    .map((block) => {
      const [heading = '', ...lines] = block.split('\n');
      const m = /^Version\s+([\d.]+)(?:\s+[–-]\s+(.+))?/.exec(heading.trim());
      const body = lines.join('\n');
      const [introPart = '', ...bullets] = body.split(/^- /m);
      return {
        version: m?.[1] ?? heading.trim(),
        date: m?.[2]?.trim(),
        intro: introPart
          .split(/\n\s*\n/)
          .map((p) => p.replace(/\s*\n\s*/g, ' ').trim())
          .filter(Boolean),
        // a bullet may wrap onto indented continuation lines
        items: bullets.map((item) => item.replace(/\s*\n\s*/g, ' ').trim()),
      };
    });
}
